import React, { useEffect } from 'react';
import CalendarHeader from './Header/CalendarHeader';
import { CircularProgress, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import AppointmentColumn from './Appointment/AppointmentColumn';
import HoursColumn from './Header/HoursColumn';
import moment from 'moment-jalaali';
import * as type from '../../redux/Appointment/AppointmentType';
import { createLoadingSelector } from '../../redux/Loading/LoadingSelector';

const styles = makeStyles({
    container: {
        width: '100%',
        // height: "100%",
        // overflow: 'auto',
        padding: '40px',
        backgroundColor: '#f2f4fa',
        direction: 'rtl',
        textAlign: 'right'
    },
    calendarContainer: {
        backgroundColor: 'white',
        // margin: (props) => (props.isPatientHeader ? '0' : '20px'),
        borderRadius: '6px',
        position: 'relative'
        // maxHeight: 'calc(100vh - 104px)',
        // height: 'calc(100vh - 104px)',
        // height: 'calc(100vh - 210px)'
    },
    mainContainer: {
        display: 'flex',
        maxHeight: 'calc(100vh - 187px)',
        overflow: 'auto',
        position: 'relative'
    },
    loadingContainer: {
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        '& > div': {
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }
    },
    progress: {
        color: '#063f5e'
    },
    appointmentContainer: {
        display: 'flex',
        width: '100%',
        height: '100%',
        paddingTop: '10px',
        paddingBottom: '13px'
    },
    bottomOpaque: {
        position: 'absolute',
        bottom: '0',
        left: '0',
        right: '0',
        height: '13px',
        background: '#fff',
        opacity: '.7'
    }
});
const Calendar = () => {
    useEffect(() => {
        const elem = document.getElementById('hour-8');
        elem.scrollIntoView();
    }, []);
    const appointments = useSelector((state) => state.appointment?.appointments);
    const loadingSelector = createLoadingSelector(type.GET_APPOINTMENTS.REQUEST);
    const isLoading = useSelector(loadingSelector);
    const week = useSelector((state) => state.appointment?.date?.week);
    const classes = styles();
    return (
        <>
            <div className={classes.calendarContainer}>
                <CalendarHeader />
                <div className={classes.mainContainer}>
                    <HoursColumn />
                    <div className={classes.appointmentContainer}>
                        {week.map((dayOfWeek, index) => (
                            <AppointmentColumn
                                key={index}
                                appointments={appointments?.filter(
                                    (val) =>
                                        moment(val.appointed).format('YYYY-MM-DD') === dayOfWeek
                                )}
                                date={dayOfWeek}
                            />
                        ))}
                    </div>
                </div>
                {isLoading && (
                    <div className={classes.loadingContainer}>
                        <div>
                            <CircularProgress classes={{ colorPrimary: classes.progress }} />
                        </div>
                    </div>
                )}
                <div className={classes.bottomOpaque}></div>
            </div>
        </>
    );
};

export default Calendar;
